import { useQuery } from "@tanstack/react-query";
import { authQueryOptions } from "@/services/auth";
import type { ActionToCheck } from "@/services/auth/auth.types";

export interface UseEntityActionAllowedArgs extends ActionToCheck {
	/** When false, the check does not run and `allowed` stays false. */
	enabled?: boolean;
}

/**
 * One `POST /valid-actions` row. `allowed` is true only after the API says so.
 * Pending, error, and false all hide the control.
 */
export function useEntityActionAllowed({
	enabled = true,
	...action
}: UseEntityActionAllowedArgs): { allowed: boolean; isPending: boolean } {
	const query = useQuery({
		...authQueryOptions.checkAction(action),
		enabled: enabled && action.name.length > 0,
	});

	return {
		allowed: query.data === true,
		isPending: enabled && query.isPending,
	};
}
